import { render } from "./StoryBankDetails.vue?vue&type=template&id=27fbc14c&scoped=true"
import script from "./StoryBankDetails.vue?vue&type=script&lang=js"
export * from "./StoryBankDetails.vue?vue&type=script&lang=js"

import "./StoryBankDetails.vue?vue&type=style&index=0&id=27fbc14c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fbc14c"]])

export default __exports__